const USERS = {
    LIVE_USER: 'VTXf2XZvKsa5PpFanlZUPa96vqG3',
    ADMINS: [
        'tQjT8wO02CVVhBia0gCMaYR3Xpc2', // carrino
        'quZSnZ8lKLSVEeBh8A9EpfL8cjv1', // michael
        'kt4e2j9PpNZgkwUJwEYm46vxNNk1', // brennan
    ],
    ROLES: {
        ADMIN: 'TftwE20kPMPmiVHh4CGp',
        MANAGER: 'NA8zQnDA6hv1REniQ34T',
        SUPPORT: 'O4SvDiJp3BIq0XpIvV50',
        MANUFACTURING: 'X5tyllhOEQgCsdiRPM5V',
        DEVELOPER: 'BiW3zpSwYlnltmmEMihH',
        UNITY_DEVELOPER: '7jVsStW46BXaUc8StQxt',
        USER: 'USER',
        PRO_USER: 'c5qUkS59eGOq8LJxdw0N',
        PLAY_USER: 'zKBzw6LO2AQe9dL3OMcL',
        BETA_USER: 'JFjfCQxgLKiPo4XRojuH',
        EARLY_ACCESS_USER: 'PN3Tkn7i9hROO9tVPWw2',
        STORE: 'wt4Rbz3maTORJTiLYjyH',
        PREMIUM_STORE: 'nAV99wL0kYuWYZA6q2pS',
        DEBUG_THROWS: 'LvjKBti79q8C0vzq6z37',
    },
} as const

export default USERS
